import { injectable, inject } from 'inversify';
import { backendUrl } from 'src/config';
import HttpClient from 'src/features/http';
import {
  ComplaintsServiceInterface,
  OrderComplaintRequestParams,
  OrderComplaintResponse,
} from './ComplaintsService.types';

@injectable()
class ComplaintsService implements ComplaintsServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  async postOrderComplaint({
    accessToken,
    ...params
  }: OrderComplaintRequestParams) {
    return this.client
      .getClient()
      .post<OrderComplaintResponse>('/order-complaints/', params, {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });
  }
}

export default ComplaintsService;
